(function () {
  try {
    if (window.Shopify && Shopify.designMode) return;
  } catch (e) {}

  var qs = window.location.search || "";
  if (qs.indexOf("no_redirect=1") !== -1) return;
  if (qs.indexOf("preview_theme_id=") !== -1) return;
  if ((window.location.pathname || "").indexOf("/admin") === 0) return;

  // If user has manually chosen language in this session → NEVER auto-redirect
  try {
    if (sessionStorage.getItem("manual_language_chosen") === "1") {
      return;
    }
  } catch (e) {}

  // Only run on homepage
  var path = window.location.pathname || "/";
  if (path !== "/" && path !== "") return;

  function isNorwegianBrowser() {
    var langs = navigator.languages || [navigator.language || ""];
    for (var i = 0; i < langs.length; i++) {
      var l = String(langs[i]).toLowerCase();
      if (l.startsWith("nb") || l.startsWith("nn") || l.startsWith("no")) {
        return true;
      }
    }
    return false;
  }

  if (isNorwegianBrowser()) {
    window.location.replace("/no");
  }
})();
